/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ 'webfontloader')

  webFontLoader.load({
    google: {
      families: ['Zilla Slab:400,700', 'Plus Jakarta Sans:400,500,600,700'],
      subsets: ['latin'],
    },
  })
}
